import { FC } from 'react';
import styled from 'styled-components';

import PlanFeature from '../PlanFeature';
import { PlanFeatureProps } from '../PlanFeature/types';

export type PlanFeaturesProps = {
  title: string;
  list: PlanFeatureProps[];
};

const Title = styled.h4`
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #292a2b;
`;

const PlanFeatures: FC<PlanFeaturesProps> = ({ title, list }) => (
  <>
    <Title>{title}</Title>
    {list.map((feature, i) => (
      <PlanFeature key={i} {...feature} />
    ))}
  </>
);

export default PlanFeatures;
